import { PaymentSettingsList } from '@/features/payment-settings';
import { requireAdministratorAccess, requirePermissions } from '@/shared/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_app/settings/products/payment-methods/'
)({
  component: SettingsPaymentMethodsRoute,
  beforeLoad: async () => {
    // Espelha o guard da API: `products.catalog.read` + `@RequireGroups('insurer.administrator')`.
    const [isAdministrator, canRead] = await Promise.all([
      requireAdministratorAccess(),
      requirePermissions(['products.catalog.read']),
    ]);
    if (!isAdministrator || !canRead) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function SettingsPaymentMethodsRoute() {
  return <PaymentSettingsList />;
}
